const containerFluid = {
  paper: {
    width: '100%',
  },
};

export default containerFluid;
